import { createBrowserHistory } from "history";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { Et3ThemeProvider } from "et3-ui-library/mui";

import getCoreHistoryStore from "./stores/core/core-history-store";
import getRootStore from "./stores/core/root-store";
import getFirebaseStore from "./stores/firebase-store";
import getAppControlStore from "./stores/firebase-store/app-control";

import { ThemeProvider } from "./core/et3-theme";
import getTheme from "./core/et3-theme/getTheme";
import RouterComponent from "./routes";

const ThemedRouter = observer(() => {
  return (
    <ThemeProvider themeValue={getTheme().getThemeData.get()}>
      <Et3ThemeProvider disableCssBaseline>
        <RouterComponent />
      </Et3ThemeProvider>
    </ThemeProvider>
  );
});

const App = () => {
  const history = createBrowserHistory();

  useEffect(() => {
    const firebaseStore = getFirebaseStore();
    const appControlStore = getAppControlStore();

    getCoreHistoryStore().history.set(history);

    getRootStore().startApp();

    firebaseStore.registerIfNotificationPermissionGranted();

    appControlStore.start();

    return () => {
      firebaseStore.stopFirebaseMessaging();

      appControlStore.stop();

      getRootStore().killAppTimersAndListenners();
    };
  }, [history]);

  useEffect(() => {
    if (window.top && window.top !== window.self) {
      window.top.location.href = window.location.href;
    }
  }, []);

  return <ThemedRouter />;
};

export default App;
